import { render, staticRenderFns } from "./SideTestConfig.vue?vue&type=template&id=44484ca1&scoped=true"
import script from "./SideTestConfig.vue?vue&type=script&lang=js"
export * from "./SideTestConfig.vue?vue&type=script&lang=js"
import style0 from "./SideTestConfig.vue?vue&type=style&index=0&id=44484ca1&prod&lang=css"
import style1 from "./SideTestConfig.vue?vue&type=style&index=1&id=44484ca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44484ca1",
  null
  
)

export default component.exports